import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.EDGE,
  displayName: "Edge",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "jpd-icon",
    title: "Distribution Edge",
    valueTransformer: (value) => value,
    valueTransformerSH: (value) => {
      return { display: value !== "N/A", value: value };
    },
  },
};

export default entitlement;
